import * as React from 'react';

function Warning(): JSX.Element {
    return (
        <div className="form-group form-disclaimer">
            <b>Note:</b> the inca portal currently does not support mobile
            devices. Please log in on a larger device.
        </div>
    );
}

export default Warning;
